import SliderSeparator from './sliderSeparator'

export default SliderSeparator